export const Lotus = {
  galleries: [
    {
      name: "blooming",
      media: [
        {
          source:
            "https://www.datocms-assets.com/40484/1695302798-01004_eletre_campaign_s010_mirror_comp04_rs_finalart.png",
          align: "flex-end",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302881-sh01004_s002_far_rear_comp06_th_finalart_notalent_lotus.png",
          align: "center",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302762-01004_eletre_campaign_s005_r34_comp03_rs_finalart_nolights.png",
          align: "flex-start",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302829-sh01004_001_lotus_eletre_f34_comp04_rbn_finalart_lotus.png",
          align: "flex-end",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302853-sh01004_012_lotus_eletre_side_driving_comp04_rbn_finalart.png",
          align: "center",
        },
      ],
    },
    {
      name: "light",
      media: [
        {
          source:
            "https://www.datocms-assets.com/40484/1695302501-01004_eletre_campaign_s003_yellow_f34_comp04_rs_finalart.png",
          align: "center",
          margin: "bottom",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302591-01004_eletre_campaign_s016_driver_door_comp03_re_finalart_lotus.png",
          align: "flex-end",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302566-01004_eletre_campaign_s015_mb_front_comp03_rs_finalart.png",
          align: "flex-end",
          margin: "bottom",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302612-01004_eletre_campaign_s020_rear_seat_comp01_re_finalart-1.png",
          align: "center",
          margin: "top",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695302535-01004_eletre_campaign_s004_hero_f34_comp04_re_finalart_lotus.png",
          align: "flex-start",
        },
      ],
    },
    {
      name: "pixel",
      media: [
        {
          source:
            "https://www.datocms-assets.com/40484/1695303599-01004_eletre_campaign_s013_mb_profile_comp03_re_finalart_lotus.png",
          align: "flex-end",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695303658-01004_eletre_campaign_s017_window_comp02_re_finalart_lotus.png",
          align: "flex-start",
          margin: "top",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695303738-sh01004_s006_rear_detail_comp06_th_finalart_lotus.png",
          align: "center",
          margin: "top",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695303652-i-m-very-satisfied-with-how-we-pushed-our-system-to-the-limits.png",
          align: "center",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695303678-01004_eletre_campaign_s019_dash_ps_comp02_re_finalart_lotus.png",
          align: "flex-start",
          margin: "top",
        },
        {
          source:
            "https://www.datocms-assets.com/40484/1695303717-sh01004_009_lotus_eletre_f34_detail_comp06_rbn_finalart_lotus-1.png",
          align: "flex-end",
        },
      ],
    },
  ],
};
